var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNav2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0968 1.45117H2.90323C1.30645 1.45117 0 2.75762 0 4.3544C0 5.95117 1.30645 7.25762 2.90323 7.25762H27.0968C28.6935 7.25762 30 5.95117 30 4.3544C30 2.75762 28.6935 1.45117 27.0968 1.45117Z",
    fill: "#14A2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0968 12.0967H2.90323C1.30645 12.0967 0 13.4031 0 14.9999C0 16.5967 1.30645 17.9031 2.90323 17.9031H27.0968C28.6935 17.9031 30 16.5967 30 14.9999C30 13.4031 28.6935 12.0967 27.0968 12.0967Z",
    fill: "#14A2FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0968 22.7412H2.90323C1.30645 22.7412 0 24.0477 0 25.6444C0 27.2412 1.30645 28.5477 2.90323 28.5477H27.0968C28.6935 28.5477 30 27.2412 30 25.6444C30 24.0477 28.6935 22.7412 27.0968 22.7412Z",
    fill: "#14A2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav2);
export default __webpack_public_path__ + "static/media/nav2.099e23ca5c520ba84640a72350c2adfa.svg";
export { ForwardRef as ReactComponent };